
const DEFAULT_MODE = 'windowed'
const ROOT_MOUNT_REGIONS = new Set(['root', 'global'])
const NEAREST_MOUNT_REGIONS = new Set(['nearest', 'local'])
const WINDOW_MOUNT_REGIONS = new Set(['window', 'body'])
const APPLICATION_MOUNT_REGIONS = new Set(['application', 'app'])

import {
  closeAllDialogs,
  getOpenDialogsForStackEntry,
  getNearestDialogRegion,
  getOrCreateOverlayHost,
  refreshLayeredDialog,
  registerDialogInStack,
  registerLayeredDialog,
  unregisterDialogFromStack,
  unregisterLayeredDialog,
} from '../dialog-stack.js'
import { getOrCreateLayeredOverlayHost, LAYERED_OVERLAYS_FEATURE, setOverlayOwner } from '../overlay-host.js'

function hasOpacityTransition(element) {
  const view = element.ownerDocument?.defaultView
  if (!view?.getComputedStyle) {
    return false
  }

  const style = view.getComputedStyle(element)
  const properties = String(style.transitionProperty || '').split(',').map(property => property.trim())
  const durations = String(style.transitionDuration || '').split(',').map(duration => parseFloat(duration) || 0)

  return properties.some((property, index) => (property === 'opacity' || property === 'all') && durations[index % durations.length] > 0)
}

export default {
  /* tslint:disable */
  render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpen),expression:"isOpen"}],staticClass:"ae-dialog-placeholder",attrs:{"data-ae-dialog-mode":_vm.dialogMode}},[(_vm.isDialogMode)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpen),expression:"isOpen"}],ref:"container",staticClass:"ae-dialog__container ae-dialog__backdrop",class:_vm.appliedBackdropClasses,style:(_vm.styleToApplyToBackdrop),attrs:{"data-ae-dialog-mode":_vm.dialogMode},on:{"click":_vm.clickOnBackdrop}},[_c('div',{ref:"dialog",staticClass:"ae-dialog",class:_vm.appliedDialogClasses,style:(_vm.styleToApplyToDialog),attrs:{"data-ae-dialog-mode":_vm.dialogMode,"tabindex":_vm.layered ? -1 : null},on:{"click":function($event){$event.stopPropagation();}}},[(_vm.layered && !_vm.isImmersiveAppearance && _vm.normalizedAppearance !== 'confirmation')?_c('button',{staticClass:"ae-dialog__swipe-handle",attrs:{"type":"button","aria-label":_vm.stackType === 'drillInto' ? 'Back' : 'Close dialog'},on:{"pointerdown":_vm.startSheetSwipe,"pointermove":_vm.moveSheetSwipe,"pointerup":_vm.endSheetSwipe,"pointercancel":_vm.cancelSheetSwipe,"click":_vm.dismissSheet}},[_c('span',{attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),_vm._t("default",function(){return [_c('div',{staticClass:"ae-dialog__header",style:(_vm.confirmationStyles.header)},[_vm._t("header",function(){return [_c('h2',{staticClass:"ae-dialog__title",style:(_vm.confirmationStyles.title)},[_vm._v(_vm._s(_vm.title))])]},{"close":_vm.close})],2),_vm._v(" "),_c('div',{staticClass:"ae-dialog__body",style:(_vm.confirmationStyles.body)},[_vm._t("body",null,{"close":_vm.close})],2),_vm._v(" "),_c('div',{staticClass:"ae-dialog__commands-bar",style:(_vm.confirmationStyles.footer)},[_c('div',{staticClass:"ae-dialog__commands",style:(_vm.confirmationStyles.commands)},[_vm._t("commands",function(){return _vm._l((_vm.actions),function(action){return _c('button',{key:action.id,style:(_vm.actionStyle(action)),attrs:{"type":"button","disabled":action.disabled,"autofocus":action.autofocus},on:{"click":function($event){return _vm.$emit('action', action.id)}}},[_vm._v(_vm._s(action.label))])})},{"close":_vm.close})],2)])]},{"close":_vm.close})],2)]):_c('ae-popup',{ref:"popup"},[_c('div',{staticClass:"ae-dialog ae-dialog__popup",class:Object.assign({}, _vm.dialogClasses, _vm.popupClasses),style:(_vm.styleToApplyToPopup),attrs:{"slot":"popup","data-ae-dialog-mode":"popup"},slot:"popup"},[_vm._t("default",function(){return [_c('div',{staticClass:"ae-dialog__header",style:(_vm.confirmationStyles.header)},[_vm._t("header",function(){return [_c('h2',{staticClass:"ae-dialog__title",style:(_vm.confirmationStyles.title)},[_vm._v(_vm._s(_vm.title))])]},{"close":_vm.close})],2),_vm._v(" "),_c('div',{staticClass:"ae-dialog__body",style:(_vm.confirmationStyles.body)},[_vm._t("body",null,{"close":_vm.close})],2),_vm._v(" "),_c('div',{staticClass:"ae-dialog__commands-bar",style:(_vm.confirmationStyles.footer)},[_c('div',{staticClass:"ae-dialog__commands",style:(_vm.confirmationStyles.commands)},[_vm._t("commands",function(){return _vm._l((_vm.actions),function(action){return _c('button',{key:action.id,style:(_vm.actionStyle(action)),attrs:{"type":"button","disabled":action.disabled,"autofocus":action.autofocus},on:{"click":function($event){return _vm.$emit('action', action.id)}}},[_vm._v(_vm._s(action.label))])})},{"close":_vm.close})],2)])]},{"close":_vm.close})],2)])],1)},
  staticRenderFns: [],
  /* tslint:enable */
  
  inject: ['getAeppicContext'],
  props: {
    dialogId: String,
    open: Boolean,
    fullScreen: {
      type: Boolean,
      default: null
    },
    title: String,
    actions: { type: Array, default: () => [] },
    adjustDialogSize: {
      type: Boolean,
      default: true
    },
    adjustDialogSizeOptions: {
      type: Object,
      default() {
        return {
          timeout: 1000,
          width: 150,
          height: 150
        }
      }
    },
    dialogSize: {
      type: Object,
      default() {
        return {
          width: '',
          height: ''
        }
      }
    },
    preferredMode: {
      type: String,
      default: DEFAULT_MODE,
    },
    appearance: {
      type: String,
      default: 'default',
    },
    mountRegion: {
      validator(value) {
        return typeof value === 'string' || !!(value && typeof value === 'object' && value.nodeType === 1)
      },
      default: 'auto',
    },
    backdropClose: {
      type: Boolean,
      default: true,
    },
    backdropClasses: {
      type: Object,
      default() {return {}},
    },
    backdropStyle: Object,
    dialogClasses: {
      type: Object,
      default() {return {}},      
    },
    dialogStyle: Object,
    popupClasses: {
      type: Object,
      default() {return {}},      
    },
    popupStyle: Object,
    // Layered overlays share scrims within a type and bound each type to five visible surfaces.
    stackType: {
      type: String,
      default: 'dialog',
    },
  },
  data() {
    const Aeppic = this.getAeppicContext('ae-dialog')

    return {
      Aeppic,
      defaultBackdropStyle: {},
      defaultDialogStyle: {
        minWidth: '600px',
        minHeight: '300px',
      },
      defaultPopupStyle: {},
      isOpen: this.open,
      popupOpened: false,
      stackIndex: -1,
      stackCount: 0,
      overlayElement: null,
      overlayHost: null,
      stackRegion: null,
      regionKind: 'application',
      layered: false,
      stackState: 'active',
      layeredDepth: 0,
      $_handleDialogDrillInto: null,
    }
  },
  computed: {
    confirmationStyles() {
      if (this.normalizedAppearance !== 'confirmation') return {}

      // Core SFC styles are not bundled by vue-compile; keep the appearance in
      // the shared component so it also works with server-provided stylesheets.
      return {
        dialog: {
          boxSizing: 'border-box', borderRadius: '16px', overflow: 'auto',
          width: 'min(560px, calc(100vw - 32px))', minWidth: '0', minHeight: '0',
          maxHeight: 'calc(100dvh - 32px)',
          background: 'var(--md-sys-color-surface, #fff)',
          color: 'var(--md-sys-color-on-surface, #20242c)',
          boxShadow: '0 24px 80px rgba(15, 23, 42, 0.22)',
        },
        header: { padding: '24px 28px 0' },
        title: { margin: '0', fontSize: '21px', lineHeight: '1.35', fontWeight: '650' },
        body: { padding: '12px 28px 24px', lineHeight: '1.6', color: 'var(--md-sys-color-on-surface-variant, #525b68)' },
        footer: {
          padding: '16px 24px', borderTop: '1px solid var(--md-sys-color-outline-variant, #e3e7ed)',
          background: 'var(--md-sys-color-surface-container-low, #f7f8fa)',
        },
        commands: { display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-end', gap: '8px' },
      }
    },
    styleToApplyToBackdrop() {
      return Object.assign({}, this.defaultBackdropStyle, this.backdropStyle || {}, {
        // Layered overlays: the shared scrim receives outside clicks; immersive views keep their own backdrop.
        pointerEvents: this.layered && !this.isImmersiveAppearance ? 'none' : 'auto',
        zIndex: 'auto',
      })
    },
    styleToApplyToDialog() {
      const defaultDialogStyle = this.isDockMode ? {} : this.defaultDialogStyle
      const style = Object.assign({}, defaultDialogStyle, this.confirmationStyles.dialog, this.dialogStyle || {}, {
        '--ae-dialog-stack-depth': this.visualStackDepth,
      })

      if (this.dialogSize.width || this.dialogSize.height) {
        if (this.dialogSize.width) {
          style.width = this.dialogSize.width
        }
        if (this.dialogSize.height) {
          style.height = this.dialogSize.height
        }
      }

      return style
    },
    styleToApplyToPopup() {
      return Object.assign({}, this.defaultPopupStyle, this.popupStyle || {})
    },
    stackDepth() {
      if (this.layered) {
        return this.stackState === 'active' ? 0 : 1
      }

      return Math.max(0, this.stackCount - this.stackIndex - 1)
    },
    visualStackDepth() {
      if (this.layered) {
        return this.layeredDepth
      }

      // The registry is not reactive; stackCount invalidates depth when dialogs open or close.
      if (this.stackIndex < 0 || this.stackCount === 0) {
        return 0
      }

      let depth = 0

      const openDialogs = getOpenDialogsForStackEntry(this)

      for (let index = this.stackIndex + 1; index < openDialogs.length; index += 1) {
        if (openDialogs[index]?.stackMode === this.stackMode) {
          depth += 1
        }
      }

      return depth
    },
    isTopDialog() {
      return this.stackDepth === 0
    },
    isVisuallyStacked() {
      return this.visualStackDepth > 0
    },
    dialogMode() {
      return this.stackMode
    },
    stackMode() {
      if (!this.isDialogMode) {
        return 'popup'
      }

      if (this.showFullscreen) {
        return 'fullscreen'
      }

      if (this.isDockMode) {
        return 'dock'
      }

      return DEFAULT_MODE
    },
    isImmersiveAppearance() {
      return this.normalizedAppearance === 'immersive'
    },
    stackPresentation() {
      return this.stackMode === 'popup' ? 'windowed' : this.stackMode
    },
    requiresScrim() {
      return !this.isImmersiveAppearance
    },
    overlayLayerName() {
      if (this.normalizedAppearance === 'confirmation') {
        return 'modal'
      }

      return this.isImmersiveAppearance ? 'immersive' : 'dialog'
    },
    appliedBackdropClasses() {
      return Object.assign({
        'ae-dialog__backdrop--top': this.isTopDialog,
        'ae-dialog__backdrop--stacked': this.isVisuallyStacked,
        'ae-dialog__backdrop--dock': this.isDockMode,
        'ae-dialog__backdrop--appearance-immersive': this.isImmersiveAppearance,
      }, this.backdropClasses)
    },
    appliedDialogClasses() {
      return Object.assign({
        'ae-dialog--fullscreen': this.showFullscreen,
        'ae-dialog--dock': this.isDockMode,
        'ae-dialog--top': this.isTopDialog,
        'ae-dialog--stacked': !this.isTopDialog,
        'ae-dialog--visually-stacked': this.isVisuallyStacked,
        'ae-dialog--appearance-immersive': this.isImmersiveAppearance,
        'ae-dialog--appearance-confirmation': this.normalizedAppearance === 'confirmation',
      }, this.dialogClasses)
    },
    showFullscreen() {
      if (this.isImmersiveAppearance) {
        return true
      }

      if (this.fullScreen === null && this.preferredMode === DEFAULT_MODE && this.Aeppic && this.Aeppic.Device === 'Phone' && !this.layered) {
        return true
      }

      return this.fullScreen || this.preferredMode === 'fullscreen'
    },
    isDialogMode() {
      return this.preferredMode !== 'popup'
    },
    isDockMode() {
      return this.preferredMode === 'dock'
    },
    shouldAdjustDialogSize() {
      return this.isDialogMode && this.adjustDialogSize && !this.showFullscreen && !this.isDockMode
    },
    normalizedAppearance() {
      return String(this.appearance || 'default').trim().toLowerCase()
    },
    normalizedMountRegionName() {
      if (this.mountRegion && typeof this.mountRegion === 'object' && this.mountRegion.nodeType === 1) {
        return ''
      }

      return String(this.mountRegion || 'auto').trim().toLowerCase()
    },
    isAutoMountRegion() {
      return this.normalizedMountRegionName === 'auto' || this.normalizedMountRegionName === ''
    },
    resolvedMountRegion() {
      if (this.mountRegion && typeof this.mountRegion === 'object' && this.mountRegion.nodeType === 1) {
        return this.mountRegion
      }

      const mountRegion = this.normalizedMountRegionName

      if (ROOT_MOUNT_REGIONS.has(mountRegion)) {
        return 'root'
      }

      if (NEAREST_MOUNT_REGIONS.has(mountRegion)) {
        return 'nearest'
      }

      if (WINDOW_MOUNT_REGIONS.has(mountRegion)) {
        return 'window'
      }

      if (APPLICATION_MOUNT_REGIONS.has(mountRegion)) {
        return 'application'
      }

      if (mountRegion === 'auto' || mountRegion === '') {
        return 'nearest'
      }

      return mountRegion
    },
  },
  mounted() {
    // console.log('ae-dialog:mounted')
    this.container = null
    this.region = this.findDialogRegion()
    this.originalParent = this.$el.parentNode

    if (this.open) {
      this.show()
    }
  },
  beforeDestroy() {
    this.close(true)
    this.$_clearAdjustSizeTimeout()
  },
  created() {
    this.$_observer = null
    this.$_observerUnregisterTimeout = null
    this.$_adjustTimeout = null

    this.$_isDialogGone = () => this._isDestroyed || this._isBeingDestroyed || !this.isOpen

    this.$_adjustSize = async () => {
      if (this.$_isDialogGone() || !this.$refs.dialog) {
        return
      }

      await this.Aeppic.waitForNextAnimationFrame()
      await this.Aeppic.waitForNextAnimationFrame()
      await this.Aeppic.waitForNextAnimationFrame()
      await this.Aeppic.waitForNextAnimationFrame()

      await this.Aeppic.nextRenderPass()
      await this.Aeppic.nextRenderPass()

      // jsdom teardown / $destroy can null $refs after the awaits. Destructuring
      // a null ref throws TypeError and kills the ava worker (pipelines 13130/13131).
      const dialog = this.$refs.dialog
      if (this.$_isDialogGone() || !dialog) {
        return
      }

      const { offsetWidth, clientHeight } = dialog

      const smallerThanMinimalSize = offsetWidth <= this.adjustDialogSizeOptions.width || clientHeight <= this.adjustDialogSizeOptions.height
      if (smallerThanMinimalSize) {
        this.$_setAdjustSizeTimeout()
        return
      }

      const { minWidth, minHeight } = this.defaultDialogStyle
      const minWidthAsNumber = Number(minWidth.replace('px', ''))
      const minHeightAsNumber = Number(minHeight.replace('px', ''))

      const sizeStabilized = offsetWidth >= minWidthAsNumber && clientHeight >= minHeightAsNumber
      if (sizeStabilized) {
        this.defaultDialogStyle.width = `${offsetWidth}px`
        // NOTE: add 1px to circumvent scrollbars due to unfavourable size roundings
        this.defaultDialogStyle.height = `${clientHeight + 1}px`

        this.$_clearAdjustSizeTimeout()
        return
      }

      // this.defaultDialogStyle.minWidth = offsetWidth + 'px'
      // this.defaultDialogStyle.minHeight = clientHeight  + 'px'

      this.$_setAdjustSizeTimeout()
    }

    this.$_setAdjustSizeTimeout = () => {
      if (this.$_isDialogGone()) {
        return
      }

      if (this.$_adjustTimeout) {
        this.Aeppic.clearTimeout(this.$_adjustTimeout)
      }

      this.$_adjustTimeout = this.Aeppic.setTimeout(() => {
        this.$_clearAdjustSizeTimeout()
        Promise.resolve(this.$_adjustSize()).catch((error) => {
          console.error('ae-dialog adjust size failed', error && error.message)
        })
      }, this.adjustDialogSizeOptions.timeout) 
    }

    this.$_clearAdjustSizeTimeout = () => {
      if (this.$_adjustTimeout) {
        this.Aeppic.clearTimeout(this.$_adjustTimeout)
      }
    }
  },
  methods: {
    actionStyle(action) {
      const style = {
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        minHeight: '40px', padding: '8px 16px', borderRadius: '8px',
        border: '1px solid', borderColor: 'var(--md-sys-color-outline-variant, #dce2e8)',
        background: 'var(--md-sys-color-surface, #fff)',
        color: 'var(--md-sys-color-on-surface, #20242c)',
        font: 'inherit', fontWeight: '600', whiteSpace: 'nowrap',
        cursor: action.disabled ? 'default' : 'pointer', opacity: action.disabled ? '0.5' : '1',
      }
      if (action.kind === 'danger') {
        style.background = 'var(--md-sys-color-error, #ba1a1a)'
        style.color = 'var(--md-sys-color-on-error, #fff)'
        style.borderColor = 'transparent'
      } else if (action.kind === 'primary') {
        style.background = 'var(--md-sys-color-primary, #4263eb)'
        style.color = 'var(--md-sys-color-on-primary, #fff)'
        style.borderColor = 'transparent'
      }
      return style
    },

    findRootDialogRegion() {
      const ownerDocument = this.$el.ownerDocument || document

      return this.Aeppic?.rootEl
        || ownerDocument.querySelector('.ae-root.ae-dialog-region')
        || ownerDocument.querySelector('.ae-root')
        || ownerDocument.body
    },
    findNearestDialogRegion() {
      const ancestorRegion = getNearestDialogRegion(this.$el, null)

      if (ancestorRegion) {
        return ancestorRegion
      }

      return this.findRootDialogRegion()
    },
    resolveNamedDialogRegion(regionName) {
      const ownerDocument = this.$el.ownerDocument || document

      if (!regionName) {
        return null
      }

      if (regionName.startsWith('#') || regionName.startsWith('.') || regionName.includes('[') || regionName.includes(' ')) {
        return ownerDocument.querySelector(regionName)
      }

      return ownerDocument.getElementById(regionName) || ownerDocument.querySelector(regionName)
    },
    findDialogRegion() {
      if (this.resolvedMountRegion && typeof this.resolvedMountRegion === 'object' && this.resolvedMountRegion.nodeType === 1) {
        return this.resolvedMountRegion
      }

      if (this.isAutoMountRegion && this.$el.closest?.('.ae-developer')) {
        return this.$el.ownerDocument?.body || document.body
      }

      if (this.resolvedMountRegion === 'root') {
        return this.findRootDialogRegion()
      }

      if (this.resolvedMountRegion === 'window') {
        return this.$el.ownerDocument?.body || document.body
      }

      if (this.resolvedMountRegion === 'application') {
        return this.findNearestDialogRegion()
      }

      const namedRegion = this.resolveNamedDialogRegion(this.resolvedMountRegion)
      if (namedRegion) {
        return namedRegion
      }

      return this.findNearestDialogRegion()
    },
    moveToDialogRegion() {
      this.container = this.$refs.container

      if (!this.container || !this.region) {
        return
      }

      this.overlayHost = getOrCreateOverlayHost(this.region) || this.region
      this.overlayElement = this.container
      this.stackRegion = this.overlayHost
      this.regionKind = this.resolveRegionKind(this.region)
      this.container.dataset.aeDialogRegionKind = this.regionKind
      this.overlayHost.appendChild(this.container)
    },
    resolveRegionKind(region) {
      if (this.resolvedMountRegion === 'window' || this.resolvedMountRegion === 'root') {
        return 'window'
      }

      const ownerDocument = region?.ownerDocument || this.$el.ownerDocument || document

      if (region === ownerDocument.body || region === ownerDocument.documentElement) {
        return 'window'
      }

      return 'application'
    },
    moveToOriginalPosition() {
      if (this.container == null) {
        return
      }

      if (this.container.parentNode === this.$el) {
        return
      }

      this.$el.appendChild(this.container)
    },
    clickOnBackdrop() {
      if (this.backdropClose && this.isTopDialog) {
        this.close()
      }
    },
    handleDialogDrillInto(event) {
      if (!event || event.defaultPrevented) {
        return
      }

      const detail = event.detail || {}

      event.preventDefault()
      event.stopPropagation()

      if (detail.mode === 'event') {
        return
      }

      if (detail.mode === 'navigate') {
        closeAllDialogs()
        this.Aeppic.navigateTo(detail.targetDocument)
        return
      }

      this.Aeppic.showDrillIntoDialog(detail.targetDocument, {
        ...(detail.dialogOptions || {}),
        sourceElement: detail.sourceElement,
        sourceContext: detail.sourceContext,
        preferredMode: detail.preferredMode || detail.dialogOptions?.preferredMode || 'dock',
        backdropClose: detail.dialogOptions?.backdropClose !== false,
      }).catch((error) => {
        console.error('Could not show drill-in dialog from dialog stack', error)
      })
    },
    registerDialogDrillIntoListener() {
      if (!this.$refs.container || this.$_handleDialogDrillInto) {
        return
      }

      this.$_handleDialogDrillInto = (event) => this.handleDialogDrillInto(event)
      this.$refs.container.addEventListener('ae-drill-into', this.$_handleDialogDrillInto, true)
    },
    unregisterDialogDrillIntoListener() {
      if (!this.$refs.container || !this.$_handleDialogDrillInto) {
        return
      }

      this.$refs.container.removeEventListener('ae-drill-into', this.$_handleDialogDrillInto, true)
      this.$_handleDialogDrillInto = null
    },
    dismissSheet(event) {
      if (event && this.$_sheetSuppressClick) {
        this.$_sheetSuppressClick = false
        return
      }
      if (this.isTopDialog) {
        // Same path as Back/Escape; the application owns cancel/save semantics.
        this.close()
      }
    },
    startSheetSwipe(event) {
      const view = this.$el.ownerDocument.defaultView
      if (!this.isTopDialog || event.pointerType === 'mouse' || !view?.matchMedia?.('(max-width: 720px), (max-width: 1000px) and (max-height: 560px)').matches) {
        return
      }
      this.$_sheetSuppressClick = false
      this.$_sheetSwipe = { pointerId: event.pointerId, x: event.clientX, y: event.clientY, distance: 0 }
      event.currentTarget.setPointerCapture?.(event.pointerId)
    },
    moveSheetSwipe(event) {
      const swipe = this.$_sheetSwipe
      if (!swipe || swipe.pointerId !== event.pointerId) {
        return
      }
      const direction = this.stackType === 'drillInto' ? 1 : -1
      const vertical = (event.clientY - swipe.y) * direction
      const horizontal = Math.abs(event.clientX - swipe.x)
      swipe.distance = horizontal > Math.abs(vertical) ? 0 : Math.max(0, vertical)
      this.$refs.dialog?.style.setProperty('--ae-sheet-drag', `${swipe.distance * direction}px`)
    },
    endSheetSwipe(event) {
      const swipe = this.$_sheetSwipe
      if (!swipe || swipe.pointerId !== event.pointerId) {
        return
      }
      // Avoid the synthetic click dismissing a sheet after a short/cancelled drag.
      this.$_sheetSuppressClick = true
      const distance = swipe.distance
      this.cancelSheetSwipe()
      if (distance >= 80) {
        this.dismissSheet()
      }
    },
    cancelSheetSwipe() {
      this.$_sheetSwipe = null
      this.$refs.dialog?.style.removeProperty('--ae-sheet-drag')
    },
    close(noEmit = false) {
      this.cancelSheetSwipe()
      this.$_clearAdjustSizeTimeout()
      this.isOpen = false

      if (this.isDialogMode) {
        if (this.layered) {
          this.removeFromOverlayLayer()
        } else {
          this.unregisterFromDialogStack()
        }
        this.unregisterDialogDrillIntoListener()
        this.moveToOriginalPosition()
        // this.defaultDialogStyle.minHeight = '300px'
        // this.defaultDialogStyle.minWidth = '600px'
        this.defaultDialogStyle.height = null
        this.defaultDialogStyle.width = null
      } else {
        this.$refs.popup.close()
        this.popupOpened = false
      }

      if (!noEmit) {
        this.$emit('close')
      }
    },
    show({ from, to, noEmit = false } = { from: null, to: null, noEmit: false }) { 
      this.isOpen = true

      if (!this.isDialogMode) {
        if (from) {
          const attachedBase = from || this.$el
          this.$refs.popup.open({ target: attachedBase, data: {} })
          this.popupOpened = true

          if (!noEmit) {
            this.Aeppic.nextRenderPass().then(() => {
              this.$emit('open')
            })
          }
          return
        } else {
          console.warn('Dialog cannot open as popup without a designated `from` element')
        }
      }

      this.layered = this.shouldUseLayeredOverlays()

      if (this.layered) {
        this.showInOverlayLayer()
      } else {
        this.region = this.findDialogRegion()
        this.moveToDialogRegion()
        this.registerInDialogStack()
      }

      this.registerDialogDrillIntoListener()

      if (this.shouldAdjustDialogSize) {
        this.$_setAdjustSizeTimeout()
      }
    },
    registerInDialogStack() {
      registerDialogInStack(this)
    },
    unregisterFromDialogStack() {
      unregisterDialogFromStack(this)
    },
    shouldUseLayeredOverlays() {
      if (!this.Aeppic?.Features?.isEnabled?.(LAYERED_OVERLAYS_FEATURE)) {
        return false
      }

      // Developer tooling keeps its own window host and never joins the application stack.
      return !(this.isAutoMountRegion && this.$el.closest?.('.ae-developer'))
    },
    showInOverlayLayer() {
      this.container = this.$refs.container

      if (!this.container) {
        return
      }

      const ownerDocument = this.$el.ownerDocument || document
      const layer = getOrCreateLayeredOverlayHost(ownerDocument).layer(this.overlayLayerName)

      this.overlayElement = this.container
      this.overlayHost = layer
      this.stackRegion = layer
      this.regionKind = 'window'
      this.stackState = 'active'
      this.container.dataset.aeDialogRegionKind = 'window'
      this.container.dataset.aeOverlayLayer = this.overlayLayerName
      this.container.dataset.aeStackType = this.stackType
      // The surface lives in the overlay layer, but its logical owner stays where the dialog was declared.
      setOverlayOwner(this.container, this.$el)
      registerLayeredDialog(this, layer)

      this.$nextTick(() => {
        if (this.isOpen && this.stackState === 'active' && !this.container?.contains(ownerDocument.activeElement)) {
          this.focusStackSurface()
        }
      })
    },
    removeFromOverlayLayer() {
      unregisterLayeredDialog(this)
      this.$_stackTransitionToken = null

      const container = this.overlayElement

      if (container) {
        setOverlayOwner(container, null)
        container.removeAttribute('hidden')
        container.removeAttribute('inert')
        delete container.dataset.aeStackState
        delete container.dataset.aeStackTransition
        delete container.dataset.aeOverlayLayer
        delete container.dataset.aeStackType
      }
    },
    applyStackProjection({ state, depth }) {
      const previousState = this.stackState
      const container = this.overlayElement

      this.stackState = state
      this.layeredDepth = depth

      if (!container) {
        return
      }

      container.dataset.aeStackState = state

      if (state === 'active') {
        container.removeAttribute('inert')
      } else {
        container.setAttribute('inert', '')
      }

      if (state === 'hidden' && previousState !== 'hidden') {
        this.collapseStackSurface(container)
      } else if (state !== 'hidden' && previousState === 'hidden') {
        this.restoreStackSurface(container)
      }
    },
    collapseStackSurface(container) {
      const token = {}
      this.$_stackTransitionToken = token
      container.dataset.aeStackTransition = 'collapsing'

      // display:none cannot animate, so it is applied once the fade-out has finished.
      const finish = () => {
        if (this.$_stackTransitionToken !== token) {
          return
        }

        this.$_stackTransitionToken = null
        delete container.dataset.aeStackTransition
        container.setAttribute('hidden', '')
        this.emitStackVisibility(false)
      }

      if (!hasOpacityTransition(container)) {
        finish()
        return
      }

      const onTransitionEnd = (event) => {
        if (event.target !== container || event.propertyName !== 'opacity') {
          return
        }

        container.removeEventListener('transitionend', onTransitionEnd)
        container.removeEventListener('transitioncancel', onTransitionEnd)
        finish()
      }

      container.addEventListener('transitionend', onTransitionEnd)
      container.addEventListener('transitioncancel', onTransitionEnd)
    },
    restoreStackSurface(container) {
      const wasHidden = container.hasAttribute('hidden')

      this.$_stackTransitionToken = null
      container.removeAttribute('hidden')

      if (wasHidden && hasOpacityTransition(container)) {
        // Become visible first, then fade in from the collapsed state.
        container.dataset.aeStackTransition = 'collapsing'
        void container.offsetWidth
      }

      delete container.dataset.aeStackTransition

      if (wasHidden) {
        this.emitStackVisibility(true)

        if (this.shouldAdjustDialogSize) {
          this.$_setAdjustSizeTimeout()
        }
      }
    },
    emitStackVisibility(visible) {
      this.$emit('visibility', visible)
      this.$refs.dialog?.dispatchEvent(new CustomEvent('ae-dialog-visibility-change', { detail: { visible } }))
    },
    focusStackSurface() {
      const dialog = this.$refs.dialog

      if (!dialog || typeof dialog.focus !== 'function') {
        return
      }

      const autofocusTarget = dialog.querySelector('[autofocus]')
      const target = autofocusTarget && typeof autofocusTarget.focus === 'function' ? autofocusTarget : dialog

      target.focus({ preventScroll: true })
    },
  },
  watch: {
    open() {
      if (this.open) {
        this.show()
      } else {
        this.close()
      }
    },
    mountRegion() {
      this.region = this.findDialogRegion()
    },
    preferredMode() {
      this.region = this.findDialogRegion()
    },
    fullScreen() {
      this.region = this.findDialogRegion()
    },
    stackPresentation() {
      if (this.layered && this.isOpen) {
        refreshLayeredDialog(this)
      }
    },
  }
}
